/*
 * @Author: 李朋飞
 * @Date: 2021-12-09 14:39:27
 * @LastEditTime: 2023-05-06 13:52:01
 * @Description: 
 */
import PreviewFiles from './PreviewFiles.vue';

export default {
  install(Vue) {
    Vue.component('PreviewFiles', PreviewFiles);
  }
};


// WEBPACK FOOTER //
// ./src/components/PreviewFiles/index.js